import {ReactComponent as AttentionIcon} from "./graphics/attention.svg"
import {ReactComponent as CopyIcon} from "./graphics/copy.svg"
import {ReactComponent as InfoIcon} from "./graphics/info.svg"
import {ReactComponent as ShareIcon} from "./graphics/share.svg"
import {ReactComponent as LetterIcon} from "./graphics/letter.svg"
import {ReactComponent as MessageIcon} from "./graphics/message.svg"
import {ReactComponent as RebootIcon} from "./graphics/reboot.svg"
import {ReactComponent as FinishIcon} from "./graphics/finish.svg"
import {ReactComponent as SettingsIcon} from "./graphics/settings.svg"
import {ReactComponent as AddIcon} from "./graphics/add.svg"
import {ReactComponent as CrosslinesIcon} from "./graphics/crosslines.svg"
import {ReactComponent as AddSettingsIcon} from "./graphics/addSettings.svg"
import {ReactComponent as DownloadIcon} from "./graphics/download.svg"
import {ReactComponent as ImageIcon} from "./graphics/image.svg"
import {ReactComponent as VideoIcon} from "./graphics/video.svg"
import {ReactComponent as UpdateIcon} from "./graphics/update.svg"
import {ReactComponent as ScheduleIcon} from "./graphics/schedule.svg"
import {ReactComponent as EarthIcon} from "./graphics/earth.svg"
import {ReactComponent as DetachIcon} from "./graphics/detach.svg"
import {ReactComponent as AudioListIcon} from "./graphics/audioList.svg"
import {ReactComponent as PlayIcon} from "./graphics/play.svg"
import {ReactComponent as StopIcon} from "./graphics/stop.svg"
import {ReactComponent as VolumeIcon} from "./graphics/volume.svg"
import {ReactComponent as ResetIcon} from "./graphics/reset.svg"
import {ReactComponent as GuideIcon} from "./graphics/guide.svg"
import {ReactComponent as EnterIcon} from "./graphics/enter.svg"
import {ReactComponent as ArrowEnterIcon} from "./graphics/arrowEnter.svg"
import {ReactComponent as FileListIcon} from "./graphics/fileList.svg"
import {ReactComponent as FilePlusIcon} from "./graphics/filePlus.svg"
import {ReactComponent as FileArrowDownIcon} from "./graphics/fileArrowDown.svg"
import {ReactComponent as CommandIcon} from "./graphics/command.svg"
import {ReactComponent as ScreenIcon} from "./graphics/screen.svg"
import {ReactComponent as LockIcon} from "./graphics/lock.svg"
import {ReactComponent as BookmarkIcon} from "./graphics/bookmark.svg"
import {ReactComponent as CheckmarkIcon} from "./graphics/checkmark.svg"

/**
 * All icons MUST NOT have width, height and color attributes.
 * All icons MUST support fill property
 */
export class MonochromeIcon {
    public static readonly Attention = AttentionIcon
    public static readonly Copy = CopyIcon
    public static readonly Info = InfoIcon
    public static readonly Share = ShareIcon
    public static readonly Letter = LetterIcon
    public static readonly Message = MessageIcon
    public static readonly Reboot = RebootIcon
    public static readonly Finish = FinishIcon
    public static readonly Settings = SettingsIcon
    public static readonly Add = AddIcon
    public static readonly Crosslines = CrosslinesIcon
    public static readonly AddSettings = AddSettingsIcon
    public static readonly Download = DownloadIcon
    public static readonly Update = UpdateIcon
    public static readonly Schedule = ScheduleIcon
    public static readonly Image = ImageIcon
    public static readonly Video = VideoIcon
    public static readonly Earth = EarthIcon
    public static readonly Detach = DetachIcon
    public static readonly AudioList = AudioListIcon
    public static readonly Play = PlayIcon
    public static readonly Stop = StopIcon
    public static readonly Volume = VolumeIcon
    public static readonly Reset = ResetIcon
    public static readonly Guide = GuideIcon
    public static readonly Enter = EnterIcon
    public static readonly ArrowEnter = ArrowEnterIcon
    public static readonly FileList = FileListIcon
    public static readonly FilePlus = FilePlusIcon
    public static readonly FileArrowDown = FileArrowDownIcon
    public static readonly Command = CommandIcon
    public static readonly Screen = ScreenIcon
    public static readonly Lock = LockIcon
    public static readonly Bookmark = BookmarkIcon
    public static readonly Checkmark = CheckmarkIcon
}
